import { useEffect } from 'react'
import { NextRouter } from 'next/router'

import { EventDetectionMethod, EventType, TestPrepGrade } from '~/behavior-tracking/types'
import { logUserActivity } from '~/behavior-tracking/utility/view-event-logs.utility'

export default function usePageUnloadTracker(
  router: NextRouter,
  userId: number | null,
  testPrepGrade?: TestPrepGrade,
): void {
  useEffect(() => {
    const onBeforeUnload = async (event: { target: unknown }) => {
      if (userId == null) {
        return
      }

      if (event.target === document) {
        const activityLog = {
          eventName: EventType.LEAVE_PAGE,
          viewKey: router.asPath,
          extra: {
            detectBy: EventDetectionMethod.DOCUMENT_BEFOREUNLOAD_EVENT,
            testPrepGrade,
          },
        }

        await logUserActivity(userId, activityLog)
      }
    }

    if (userId != null) {
      window.addEventListener('beforeunload', onBeforeUnload)
    }

    return () => {
      window.removeEventListener('beforeunload', onBeforeUnload)
    }
  }, [router.asPath, testPrepGrade, userId])
}
